import React, { useEffect, useMemo, useRef } from 'react';

export type CnuMessageDetailIframePropsT = {
  html: string;
};
export type CnuMessageDetailIframeT = React.FC<CnuMessageDetailIframePropsT>;

export const CnuMessageDetailIframe: CnuMessageDetailIframeT = ({ html }) => {
  // This iframe auto-size hack is based on https://stackoverflow.com/a/67219041/3251463, JFYI.
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const [height, setHeight] = React.useState<number>(0);

  const onLoadHandler = () => {
    setHeight((iframeRef.current?.contentWindow?.document?.body?.scrollHeight || 0) + 16);
  };

  const cleanedHtml = useMemo(() => {
    const htmlCleanerRegex = /\n|\r|\t/g;

    return html.replace(htmlCleanerRegex, '');
  }, [html]);

  useEffect(onLoadHandler, [html]);

  return <iframe
    height={`${height}px`}
    onLoad={onLoadHandler}
    ref={iframeRef}
    srcDoc={cleanedHtml}
    title="messageDetail"
    data-chromatic="ignore"
    data-hj-allow-iframe=""
    src={import.meta.env.VITE_ACCOUNT_HOME_BASE_URL}
  />;
};
